import { render } from "./AuthLayoutComponent.vue?vue&type=template&id=559d3c56"
import script from "./AuthLayoutComponent.vue?vue&type=script&lang=js"
export * from "./AuthLayoutComponent.vue?vue&type=script&lang=js"

import exportComponent from "/builds/kinarya-jqdev/jqdev/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__